import { useCallback, useState } from 'react';

export const PAGE_SIZE_OPTIONS = [20, 30, 50, 75, 100];
export const DEFAULT_PAGE_SIZE = PAGE_SIZE_OPTIONS[0];

const STORAGE_KEY = 'tablePageSize';

const readStoredPageSize = () => {
  try {
    const value = Number(localStorage.getItem(STORAGE_KEY));
    return PAGE_SIZE_OPTIONS.includes(value) ? value : DEFAULT_PAGE_SIZE;
  } catch {
    return DEFAULT_PAGE_SIZE;
  }
};

/**
 * Number of items displayed per page in list tables. The choice is shared by
 * every list and remembered in the browser.
 */
export const usePageSize = () => {
  const [pageSize, setPageSizeState] = useState<number>(readStoredPageSize);

  const setPageSize = useCallback((value: number) => {
    setPageSizeState(value);
    try {
      localStorage.setItem(STORAGE_KEY, String(value));
    } catch {
      // Storage unavailable: the choice is only kept for the current page.
    }
  }, []);

  return { pageSize, setPageSize };
};
